import { GogIcon } from './GogIcon';

/**
 * author: Contributors
 * id 3B6D59D1-6329-4453-A11D-FB1D53B745F9
 * name gog
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gog.svg
 * tags
 * - Brand / Logo 
 * - Gaming / RPG 
 */
export const GogComIcon = GogIcon;
export default GogComIcon